import { faFacebook, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useSpring, animated } from "react-spring";
const Cservice = () => {
  const [colorIndex, setColorIndex] = useState(0);
  const colors = ["#01011F", "#171717", "#2D2D2D"];

  const springProps = useSpring({
    backgroundColor: colors[colorIndex],
    padding: "20px",
    textAlign: "center",
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      setColorIndex((colorIndex + 1) % colors.length);
    }, 2000);
    return () => clearInterval(intervalId);
  }, [colorIndex, colors.length]);

  return (
    <selection>
      <animated.div style={springProps}>
        <div>
          <h2 className="lg:text-5xl text-primary text-4xl text-center font-bold mt-10 pb-5">
            Contact Us
          </h2>
          <h2 className="text-3xl text-white font-bold">
            Stay connected with us
          </h2>
        </div>
        <div>
          <input
            type="email"
            placeholder="Email Address"
            className="input w-full max-w-xs my-5"
          />
          <br />
          <input
            type="text"
            placeholder="Subject"
            className="input w-full max-w-xs mb-5"
          />
          <br />
          <textarea
            className="textarea  w-full max-w-xs"
            placeholder="Your Message"
          ></textarea>{" "}
          <br />
          <input
            type="submit"
            value="Submit"
            className=" font-bold py-2 px-5 rounded mt-5 mb-10 normal-case shadow-2xl border-2 border-neutral bg-primary  text-neutral hover:bg-secondary hover:text-accent w-full max-w-xs"
          />
        </div>
        <div className="text-gray-200 text-center text-3xl">
          <a
            className="text-decoration-none text-white"
            href="https://www.facebook.com/mbaba23/"
          >
            <FontAwesomeIcon
              icon={faFacebook}
              className="p-5 hover:text-primary"
            />
          </a>
          <a
            className="text-decoration-none text-white"
            href="https://api.whatsapp.com/send?phone=1754675993"
          >
            <FontAwesomeIcon
              icon={faWhatsapp}
              className="p-5 hover:text-primary"
            />
          </a>
          <div className="mb-10">
            <p className="text-sm">
              <span className="font-bold">Phone:</span> +880 1754675993
            </p>
            <p className="text-sm">
              <span className="font-bold">Gmail: </span> mbababd24@gmail.com
            </p>
          </div>
        </div>
      </animated.div>
    </selection>
  );
};

export default Cservice;
